export { default as Note } from "./Note";
export { default as useWithNote } from "./useWithNote";

export type { NoteProps } from "./Note";
